import React from "react";

export default function Alert() {
    return (
        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M22.1716 19.0631L14.7703 7.39047C14.2778 6.61258 13.4719 6.62353 12.9794 7.4014L5.57808 19.0579C5.08552 19.8364 5.45342 20.4374 6.39572 20.4374H21.3537C22.2966 20.4374 22.6642 19.8404 22.1716 19.0631ZM13.8685 9.97428C14.3425 9.97428 14.7092 10.4808 14.6849 11.0999L14.5348 14.8304C14.5106 15.4489 14.2099 15.9554 13.8667 15.9554C13.5237 15.9554 13.2224 15.4489 13.1981 14.8304L13.0498 11.0999C13.0255 10.4808 13.3934 9.97428 13.8685 9.97428ZM13.8685 18.7655C13.2704 18.7655 12.8602 18.3425 12.8726 17.7644C12.8726 17.1738 13.2839 16.7633 13.8685 16.7633C14.4778 16.7633 14.8632 17.1738 14.8762 17.7644C14.8762 18.3425 14.4778 18.7655 13.8685 18.7655Z"
                fill="#4F6E90"/>
        </svg>
    );
}
